// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Services
import { setHasShownDarkModeSuggestion } from './darkModeSuggestionService';

// Actions
import { closePopup as closePopupAction } from '../../../../../components/popupPanel/popupActions';

// Components
import SuggestionPopupContent from '../../../../../components/popupPanel/SuggestionPopupContent';
import ModalCloseButton from '../../../../../components/modal/ModalCloseButton';
import ThemeSettingsSection from '../../../../../user/account/accountModal/interface/themeSettings/ThemeSettingsSection';

// Styles
import './DarkModeSuggestionPopup.scss';
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    closePopup: () => dispatch(closePopupAction(PopupIds.DARK_MODE_SUGGESTION, false)),
});

const DarkModeSuggestionPopupContent = (props) => {
    const { closePopup } = props;

    React.useEffect(() => {
        setHasShownDarkModeSuggestion();
    }, []);

    return (
        <SuggestionPopupContent>
            <ModalCloseButton close={closePopup} />
            <div className="body">
                <h3 className="message">Change colour scheme?</h3>
                <ThemeSettingsSection />
            </div>
        </SuggestionPopupContent>
    );
};

DarkModeSuggestionPopupContent.propTypes = {
    closePopup: PropTypes.func,
    dispatchSetDarkMode: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(DarkModeSuggestionPopupContent);
